<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="telemetry()"
  [imageUrl]="imageUrl"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    <app-floorplan-item-attachments-button
      [productItems]="productItems"
      [monitoringCategory]="MonitoringCategory.TELEMETRY"
      [monitoringItems]="monitoringItems"
      [monitoringTitle]="monitoringTitle"
    ></app-floorplan-item-attachments-button>
    <app-floorplan-item-group [floorplanItem]="telemetry()"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-custom-part-numbers [floorplanItem]="telemetry()"></app-floorplan-custom-part-numbers>
    </div>
  }
</app-floorplan-item-details>
